// User-facing release notes, newest first. The first entry is the app version (keep frontend/package.json in sync).
// Only Live releases go here; the full technical history is in CHANGELOG.md. Add a release with /release.
// audience: "all" | "tenant" (tenant users) | "staff" (warehouse staff) | "admin" (platform administrator)
export const RELEASES = [
  {
    version: "1.4.0",
    date: "2026-11-04",
    notes: [
      { audience: "all",
        en: "The receiving warehouse can now start boxing and print FNSKU labels before the tenant finishes the plan.",
        tr: "Alıcı depo, Tenant planı tamamlamadan koli yapmaya ve FNSKU etiketi yazdırmaya başlayabilir." },
      { audience: "all",
        en: "The receiving warehouse can box more units than planned when needed. The tenant sees an amber note and gets a notification.",
        tr: "Alıcı depo gerektiğinde planlanandan fazla ürünü kolileyebilir. Tenant turuncu bir uyarı görür ve bildirim alır." },
      { audience: "all",
        en: "New boxes get automatic names: \"1. Koli\", \"2. Koli\" and so on.",
        tr: "Yeni koliler otomatik isimlenir: \"1. Koli\", \"2. Koli\" gibi." },
      { audience: "all",
        en: "Marketplace labels are now listed per file on the boxing screen, and the warehouse confirms each file with \"Labels done\".",
        tr: "Pazaryeri etiketleri koli ekranında dosya dosya listelenir, depo her dosyayı \"Etiket tamam\" ile onaylar." },
      { audience: "all",
        en: "When uploading a label file, the tenant gets a warning if the page count does not match the boxes.",
        tr: "Etiket dosyası yüklerken sayfa sayısı kolilerle uyuşmazsa Tenant uyarı alır." },
    ],
  },
  {
    version: "1.3.0",
    date: "2026-11-02",
    notes: [
      { audience: "tenant",
        en: "Inbound and Stock tabs in Planning (when turned on for your account): list the goods you ordered for the sender warehouse, add them or import from Excel, and see your stock: in warehouse, on pallet, on shelf, damaged, on the way. You get a warning when a pallet takes more than the shelf holds.",
        tr: "Planlama'da Inbound ve Stok sekmeleri (hesabınız için açıksa): gönderici depoya sipariş ettiğiniz ürünleri listeleyin, tek tek ekleyin veya Excel'den yükleyin ve stoğunuzu görün: depoda, palette, rafta, hasarlı, yolda. Bir palet raftakinden fazla ürün alırsa uyarı alırsınız." },
      { audience: "tenant",
        en: "New \"R\" button in Planning: recount your own pallet line (for example 5 packs of 3 become 15) and add a short note. Changed lines are shown in amber.",
        tr: "Planlama'da yeni \"R\" butonu: kendi palet kaleminizi yeniden sayın (örneğin 3'lü 5 paket 15 olur) ve kısa bir not ekleyin. Değişen kalemler turuncu görünür." },
      { audience: "staff",
        en: "Inbound and Stock on the sender screen (for tenants that have it turned on): receive goods per delivery with one number and Enter, add photos, record goods that came without an order and set the owner later.",
        tr: "Gönderici ekranında Inbound ve Stok (açık olan Tenant'lar için): ürünleri teslimat başına tek bir sayı ve Enter ile kabul edin, fotoğraf ekleyin, siparişsiz gelen ürünleri kaydedin ve sahibini sonra belirleyin." },
      { audience: "staff",
        en: "Boxing screen: lines the tenant recounted show in amber with the old number and the note (\"Revised (was N)\").",
        tr: "Koli ekranı: Tenant'ın yeniden saydığı kalemler eski sayı ve notla birlikte turuncu görünür (\"Revize (önceki N)\")." },
      { audience: "admin",
        en: "Admin → Tenants: a new Inbound and Stock switch for each tenant (off by default). Admin → Settings: choose whether a pallet may take more than the shelf holds. There is a read-only Inbound tab.",
        tr: "Yönetim → Tenant'lar: her Tenant için yeni Inbound ve Stok anahtarı (varsayılan kapalı). Yönetim → Ayarlar: bir palet raftakinden fazla ürün alabilsin mi, seçin. Salt okunur bir Inbound sekmesi de var." },
      { audience: "admin",
        en: "File backup in DB Backup: files are copied to the backup bucket, and files deleted in the app are removed from storage after the copy.",
        tr: "DB Yedek'te dosya yedeği: dosyalar yedek kovasına kopyalanır, uygulamada silinen dosyalar kopyadan sonra depolamadan kaldırılır." },
      { audience: "all",
        en: "A \"What's new\" button in the sidebar shows what changed in each version.",
        tr: "Kenar çubuğundaki \"Yenilikler\" butonu her sürümde nelerin değiştiğini gösterir." },
    ],
  },
  {
    version: "1.2.0",
    date: "2026-10-26",
    notes: [
      { audience: "admin",
        en: "Database backups in Management → DB Backup: download an encrypted backup, set automatic backup rules, restore from a zip.",
        tr: "Veritabanı yedekleri Yönetim → DB Yedek sekmesinde: şifreli yedek indirme, otomatik yedek kuralları, zip'ten geri yükleme." },
      { audience: "all",
        en: "Maintenance mode: while the system is being restored a red banner is shown and changes cannot be saved.",
        tr: "Bakım modu: sistem geri yüklenirken kırmızı bir uyarı görünür ve değişiklikler kaydedilemez." },
    ],
  },
  {
    version: "1.1.0",
    date: "2026-10-24",
    notes: [
      { audience: "staff",
        en: "New boxing screen: store plan, box cards and a clear summary, with product images.",
        tr: "Yeni koli ekranı: mağaza planı, koli kartları ve net bir özet, ürün resimleriyle." },
      { audience: "staff",
        en: "Ready or received pallets can no longer be deleted. The \"new pallet\" sound on the sender screen was removed.",
        tr: "Hazır veya teslim alınmış palet artık silinemez. Gönderici ekranındaki \"yeni palet\" sesi kaldırıldı." },
      { audience: "tenant",
        en: "The sender warehouse can only add products that are on your product list. Add a new product to your list first.",
        tr: "Gönderici depo palete sadece sizin ürün listenizdeki ürünleri ekleyebilir. Yeni bir ürünü önce listenize ekleyin." },
      { audience: "tenant",
        en: "When a correction is requested, you can fix the pallet items yourself in Planning: change a quantity, remove or add a product.",
        tr: "Düzeltme istendiğinde palet kalemlerini Planlama'da kendiniz düzeltebilirsiniz: miktarı değiştirin, ürün çıkarın veya ekleyin." },
      { audience: "all",
        en: "You are signed out after 120 minutes without activity. Server error messages are now shown in Turkish too.",
        tr: "120 dakika işlem yapılmazsa oturum kapanır. Sunucudan gelen hata mesajları artık Türkçe de görünür." },
    ],
  },
  {
    version: "1.0.1",
    date: "2026-10-18",
    notes: [
      { audience: "all",
        en: "A fast double click no longer saves the same thing twice.",
        tr: "Hızlı çift tıklama artık aynı kaydı iki kez oluşturmaz." },
      { audience: "staff",
        en: "\"Create box\" lists only stores that still have products to box.",
        tr: "\"Koli oluştur\" sadece hâlâ kolilenecek ürünü olan mağazaları listeler." },
    ],
  },
  {
    version: "1.0.0",
    date: "2026-10-18",
    notes: [
      { audience: "all",
        en: "First live version of the new BoxPrep: every tenant sees only its own products, pallets and work.",
        tr: "Yeni BoxPrep'in ilk canlı sürümü: her tenant sadece kendi ürünlerini, paletlerini ve işlerini görür." },
      { audience: "tenant",
        en: "Plan your own pallet lines, upload FBA labels per box and get a notification at every step.",
        tr: "Kendi palet kalemlerinizi planlayın, FBA etiketlerini koli bazında yükleyin ve her adımda bildirim alın." },
      { audience: "staff",
        en: "You see the screens of the warehouses you are assigned to (sender or receiver). Labels print as one merged PDF.",
        tr: "Atandığınız depoların ekranlarını görürsünüz (gönderici veya alıcı). Etiketler tek bir birleşik PDF olarak yazdırılır." },
      { audience: "admin",
        en: "Platform management: tenants, warehouses, routes and users.",
        tr: "Platform yönetimi: tenant'lar, depolar, rotalar ve kullanıcılar." },
    ],
  },
];

export const APP_VERSION = RELEASES[0].version;

// Which audiences a signed-in user belongs to; the same fields Layout uses for the notification feed.
export function audiencesOf(user) {
  const out = new Set(["all"]);
  if (user?.membership) out.add("tenant");
  if (user?.role === "WAREHOUSE_STAFF" || (user?.warehouse_assignments || []).length > 0) out.add("staff");
  if (user?.role === "TOOLS_USER") out.add("admin");
  return out;
}

// Releases with at least one note for this user, each with only those notes.
export function releasesFor(user) {
  const aud = audiencesOf(user);
  return RELEASES
    .map(r => ({ ...r, notes: r.notes.filter(n => aud.has(n.audience)) }))
    .filter(r => r.notes.length > 0);
}
